import {
  Box,
  Typography,
  TextField,
  Grid,
  InputAdornment,
  Button,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { poppins300 } from 'theme/common.style';
import Arrow1 from 'assets/images/Arrow1.png';
const HelpCenterHome = ({ onBack }) => {
  const history = useHistory();
  const [searchText, setSearchText] = useState('');
  const [iframeUrl, setIframeUrl] = useState('');

  const data = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data);
  const classes = useStyles();

  const roleMap = {
    Agent: 'agent',
    Buyer: 'buyer',
    Vendor: 'vendor',
    Solicitor: 'solicitor',
  };

  const role = roleMap[userDetail?.primaryUserType] || '';
  const roleLabelMap = {
    buyer: 'Buyer',
    vendor: 'Seller',
    agent: 'Agent',
    solicitor: 'Solicitor',
  };

  const roleLabel = roleLabelMap[role] || '';

  const HELP_URLS = {
    buyer:
      'https://arrow-purple-c85.notion.site/ebd//43f3dc85569e4b728e0c0f6fa5ea2d07',
    agent:
      'https://arrow-purple-c85.notion.site/ebd//d8a672e6c95948579c02d1cdc0d2d2a1',
    vendor:
      'https://arrow-purple-c85.notion.site/ebd//fc39129d50304d18aab551bad83f4735',
    solicitor:
      'https://arrow-purple-c85.notion.site/ebd//8081c47a4d044f80a97e4e91ae02bd25',
  };

  const GETTING_STARTED_URLS = {
    buyer:
      'https://arrow-purple-c85.notion.site/ebd/Buyer-Articles-43f3dc85569e4b728e0c0f6fa5ea2d07?source=copy_link',
    agent:
      'https://arrow-purple-c85.notion.site/ebd/Agent-Articles-d8a672e6c95948579c02d1cdc0d2d2a1?source=copy_link',
    vendor:
      'https://arrow-purple-c85.notion.site/ebd/Seller-Articles-fc39129d50304d18aab551bad83f4735?source=copy_link',
    solicitor:
      'https://arrow-purple-c85.notion.site/ebd/Solicitor-Articles-8081c47a4d044f80a97e4e91ae02bd25?source=copy_link',
  };

  const GUIDE_URLS = {
    buyer:
      'https://arrow-purple-c85.notion.site/ebd/How-to-guides-359f38d0ebe480ca91f2df494590efd4?source=copy_link',
    agent:
      'https://arrow-purple-c85.notion.site/ebd/How-to-guides-359f38d0ebe480dd83eedb567da38ca4?source=copy_link',
    vendor:
      'https://arrow-purple-c85.notion.site/ebd/How-to-guides-359f38d0ebe48089bdf6c03c84a59c34?source=copy_link',
    solicitor:
      'https://arrow-purple-c85.notion.site/ebd/How-to-guides-359f38d0ebe480489820f25cbd16e59a?source=copy_link',
  };

  const handleSearch = () => {
    if (!searchText) return;

    setIframeUrl(`${HELP_URLS[role]}?q=${searchText}`);
  };

  const topics = [
    {
      title: `${roleLabel} Articles`,
      desc: `Learn how to navigate retreX as a ${role}.`,
      type: 'getting-started',
    },
    {
      title: 'How To Guides',
      desc: 'Access instructional how-to guides for common tasks in retreX.',
      type: 'guides',
    },
    {
      title: 'Still Need Help?',
      desc: 'Submit a request for assistance.',
      type: 'support',
    },
  ];
  return (
    <Box
      sx={{
        height: '100%',
        minHeight: '100vh',
        backgroundColor: '#F9FAFB',
      }}
    >
      {/* SHOW HOME PAGE */}
      {!iframeUrl && (
        <>
          {/* HERO SECTION */}

          {/* BACK TO PREVIOUS LINK */}
          <Box className={classes.backtogrid}>
            <img alt="arrow" src={Arrow1} />
            <Typography
              onClick={() => {
                if (onBack) {
                  onBack();
                } else {
                  history.goBack();
                }
              }}
              className={classes.backto}
            >
              Back to Previous
            </Typography>
          </Box>
          <Box
            sx={{
              height: '300px',
              background:
                'linear-gradient(90deg, rgb(108, 42, 210) 0%, rgb(119, 207, 254) 100%)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              color: '#FFFFFF',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins',
                fontWeight: 600,
                fontSize: '34px',
                mb: '20px',
              }}
            >
              Hi {userDetail?.userName}, How can we help?
            </Typography>

            {/* SEARCH */}
            <Box display="flex" alignItems="center">
              <TextField
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search"
                onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: '#9CA3AF' }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  width: '380px',
                  backgroundColor: '#F3F4F6',
                  borderRadius: '6px',

                  '& .MuiOutlinedInput-root': {
                    height: '44px',
                    padding: '0 12px',
                    display: 'flex',
                    alignItems: 'center',
                    fontFamily: 'Poppins',
                  },

                  '& .MuiOutlinedInput-input': {
                    fontFamily: 'Poppins',
                    fontSize: '14px',
                    color: '#111827',
                  },

                  '& .MuiInputBase-input::placeholder': {
                    fontFamily: 'Poppins',
                    fontSize: '14px',
                    color: '#9CA3AF',
                    opacity: 1,
                  },
                }}
              />
              <Button
                variant="contained"
                onClick={handleSearch}
                disabled={!searchText}
                sx={{
                  height: '44px',
                  ml: '20px',
                  textTransform: 'none',
                  fontFamily: 'Poppins',
                  fontWeight: 500,
                  fontSize: '14px',
                  borderRadius: '6px',
                  boxShadow: 'none',
                  px: 3,
                  bgcolor: '#4CA4D6',
                  '&:hover': {
                    bgcolor: '#3293d0',
                  },
                }}
              >
                Search
              </Button>
            </Box>
          </Box>

          {/* STATIC CONTENT */}
          <Box
            sx={{
              maxWidth: '1200px',
              margin: '0 auto',
              mt: '30px',
              px: '24px',
            }}
          >
            <Box
              sx={{
                backgroundColor: '#F3F4F6',
                borderRadius: '10px',
                padding: '28px 32px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
              }}
            >
              <Box mb={2}>
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontWeight: 600,
                    fontSize: '18px',
                  }}
                >
                  Common Topics
                </Typography>
              </Box>
              <Grid container spacing={4}>
                {topics.map((item, index) => (
                  <Grid item xs={12} md={4} key={index}>
                    <Box mb={2}>
                      <Typography
                        sx={{
                          fontFamily: 'Poppins',
                          fontWeight: 600,
                          fontSize: '16px',
                        }}
                      >
                        {item.title}
                      </Typography>

                      <Box mb={2}>
                        <Typography
                          sx={{
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            color: '#6B7280',
                            lineHeight: '18px',
                          }}
                        >
                          {item.desc}
                        </Typography>
                      </Box>
                      {item.type === 'support' ? (
                        <Button
                          variant="contained"
                          onClick={() =>
                            setIframeUrl(
                              'https://arrow-purple-c85.notion.site/ebd/356b5350769d419aa48f014ab60236fb'
                            )
                          }
                          sx={{
                            marginTop: '3px',
                            height: '32px',
                            textTransform: 'none',
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            borderRadius: '4px',
                            bgcolor: '#4CA4D6',
                            '&:hover': {
                              bgcolor: '#3293d0',
                            },
                            boxShadow: 'none',
                            px: 2,
                          }}
                        >
                          Submit Request
                        </Button>
                      ) : (
                        <Typography
                          onClick={() => {
                            if (item.type === 'getting-started') {
                              setIframeUrl(GETTING_STARTED_URLS[role]);
                            } else if (item.type === 'guides') {
                              setIframeUrl(GUIDE_URLS[role]);
                            }
                          }}
                          sx={{
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            color: '#2563EB',
                            cursor: 'pointer',
                          }}
                        >
                          {item.type === 'guides'
                            ? 'See all How-to-Guides'
                            : 'See all articles'}
                        </Typography>
                      )}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        </>
      )}
      {/* INLINE IFRAME */}
      {iframeUrl && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: 'calc(100vh - 64px)',
            backgroundColor: '#FFFFFF',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          {/* TOP BAR */}
          <Box
            sx={{
              height: '60px',
              minHeight: '60px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              px: '20px',
              borderBottom: '1px solid #E5E7EB',
              backgroundColor: '#FFFFFF',
            }}
          >
            <Box className={classes.backtogrid}>
              <img alt="arrow" src={Arrow1} />
              <Typography
                onClick={() => setIframeUrl('')}
                className={classes.backto}
              >
                Back to Previous
              </Typography>
            </Box>
          </Box>

          {/* IFRAME */}
          <Box
            sx={{
              flex: 1,
              height: '100%',
              overflow: 'hidden',
            }}
          >
            <iframe
              src={iframeUrl}
              title="Help Center"
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                display: 'block',
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default HelpCenterHome;
const useStyles = makeStyles(() => ({
  backtogrid: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '20px',
    height: '8%',
  },
  labeltext: {
    fontFamily: 'poppins',
    fontSize: '32px',
    color: '#112347',
    fontWeight: 600,
  },
  backto: {
    color: '#6C2AD2',
    ...poppins300,
    fontSize: '14px',
    cursor: 'pointer',
    py: '15px',
  },
  labelgrid: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px',
    height: '7%',
  },
  wholecontainer: {
    flex: 1,
    minHeight: 0,
  },

  subcontainer1: {
    width: '350px',
  },

  subcontainer2: {
    flexGrow: 1,
    height: '100%',
  },

  slideInRight: {
    animation: '$slideInRight 0.4s ease-out',
  },

  slideOutBottom: {
    animation: '$slideOutBottom 0.4s ease-out',
  },

  '@keyframes slideInRight': {
    from: { transform: 'translateX(100%)' },
    to: { transform: 'translateX(0)' },
  },

  '@keyframes slideOutBottom': {
    from: { transform: 'translateY(0)' },
    to: { transform: 'translateY(100%)' },
  },
  horizontalDivider: {
    width: '100%',
    height: '1px',
    backgroundColor: '#8d8d8d',
    marginTop: '5px',
    marginBottom: '10px',
  },
}));
